import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IBackofficeButtonProps } from './IBackofficeButton';
import { endpoint } from '../../../../pages';
import { useAppDispatch, useAppSelector } from '../../../../../reduxService/hooks';
import { selectProjectInfo, setProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { UnitOfMeasure } from '../../../../enum/project';

const BackofficeButton = (props: IBackofficeButtonProps) => {
    const { t } = useTranslation();
    const info = useAppSelector(selectProjectInfo);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const handleClick = () => {
        navigate(endpoint.backoffice);
        let infoP = info.data ?? { city: '', client: '', company: '', country: '', name: '', author: '' };
        dispatch(
            setProjectInfo({
                ...infoP,
                unitOfMeasure: UnitOfMeasure.SI,
            }),
        );
    };
    return (
        <button type='button' className={props.className} onClick={handleClick}>
            <i className='fa-solid fa-screwdriver-wrench' />
            {t('Back Office')}
        </button>
    );
};

export default BackofficeButton;
